import { Button, Dialog } from '@chakra-ui/react';

import { UseOpenCloseReturn } from '~/core/hooks/useOpenClose';

type UnsavedType = {
  modalApi: UseOpenCloseReturn;
  close: () => void;
  text?: {
    header: string;
    exit: string;
    return: string;
    body: string;
  };
};

const defaultText = {
  exit: 'Discard changes',
  return: 'Go back',
  header: 'Unsaved changes',
  body: 'Are you sure you wish to navigate away before saving?',
};

// TODO: @haxxxton this is very similar to the ConfirmAction and TwoOptionDialog components
function UnsavedModal({ modalApi, close, text = defaultText }: UnsavedType) {
  return (
    <Dialog.Root
      onOpenChange={modalApi.onOpenChange}
      open={modalApi.open}
      placement="center"
      role="alertdialog"
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header fontSize="lg" fontWeight="bold">
            {text.header}
          </Dialog.Header>

          <Dialog.Body>{text.body}</Dialog.Body>

          <Dialog.Footer>
            <Dialog.ActionTrigger asChild>
              <Button onClick={modalApi.onClose}>{text.return}</Button>
            </Dialog.ActionTrigger>
            <Button colorPalette="red" ml={3} onClick={close} variant="solid">
              {text.exit}
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}

export default UnsavedModal;
